import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http/http.service';

@Service()
export class ProjectAdminDataService {
  private readonly http = inject(HttpService);

  async addAdminsToProjectAsync(projectId: string, userIds: string[]): Promise<number> {
    return await this.http.postObjectAsync<string[], number>(`projects/${projectId}/admins`, userIds);
  }

  async removeAdminFromProjectAsync(projectId: string, userId: string): Promise<number> {
    return await this.http.deleteAsync<number>(`projects/${projectId}/admins/${userId}`);
  }
}
